import ReactDOM from "react-dom/client";
import { X1DarkMode } from "@x1-theme/X1DarkMode";
import { X1StyleXSheet } from "@x1-theme/X1StyleXSheet";

import App from "./app";

import "./css/app.css";

const rootElement = document.getElementById("x1-root");

if (!rootElement.innerHTML) {
  X1DarkMode.initDarkMode();
  X1StyleXSheet.rootStyleSheet.injectTheme();

  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
}
